import CommonTable, { type TableColumn } from "@/components/common/CommonTable"
import MainHeading from "@/components/common/MainHeading"
import Layout from "@/components/layout/Layout"
import { Plus, Eye, MoreHorizontal } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { RoutesLink } from "@/utility/RouteLinks"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

const MyOd: React.FC = () => {
    const navigate = useNavigate();

    const columns: TableColumn[] = [
        // Date	Location	Purpose	Status
        {
            key: "date",
            header: "Date",
        },
        {
            key: "location",
            header: "Location",
        },
        {
            key: "purpose",
            header: "Purpose",
        },
        {
            key: "status",
            header: "Status",
        },
        {
            key: "action",
            header: "Action",
            render: () => (
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="ghost"
                            className="h-9 w-9 rounded-full hover:bg-slate-100"
                        >
                            <MoreHorizontal size={18} />
                        </Button>
                    </DropdownMenuTrigger>

                    <DropdownMenuContent align="end">
                        <DropdownMenuItem onClick={() => navigate("/super-admin/od-detail")}>
                            <Eye className="mr-2 h-4 w-4" />
                            View OD
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            ),
        },


    ]

    const data = [
        {
            date: "2022-01-01",
            location: "Work from home",
            purpose: "Work from home",
            status: "Approved",
        },
        {
            date: "2022-01-01",
            location: "Work from home",
            purpose: "Work from home",
            status: "Approved",
        }
    ]
    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading title="My OD Records" buttonIcon={<Plus />} buttonText="Create OD"
                    onClick={() => navigate(RoutesLink.createOd)} />
                <CommonTable columns={columns} data={data} />
            </div>
        </Layout>
    )
}

export default MyOd